import React from "react";
import resumeFile from "../documents/RiteshMistri.pdf";

const Resume = ({ classicHeader, darkTheme }) => {
  const educationDetails = [
    {
      yearRange: "2010 - 2013",
      title: "Diploma - Computer Engineering",
      place: "A. Y. Dadabhai Technical Institute - GTU",
      desc: "In diploma program may cover topics related to networking, including network protocols, network administration, and network security. Students acquire skills in configuring and maintaining computer networks and ensuring their security and performance.",
    },
    {
      yearRange: "2013 - 2016",
      title: "Computer Engineering",
      place: "Vidhyadeep University",
      desc: "Computer engineers are responsible for designing and building computer hardware, such as processors, memory systems, and input/output devices. They also develop and optimize computer software, ranging from low-level firmware to high-level applications. Computer engineers work on various aspects of computer systems, including computer architecture, digital logic design, networking, and embedded systems.",
    },
    
    // {
    //   yearRange: "2009 - 2012",
    //   title: "Master Degree",
    //   place: "Harvard University",
    //   desc: "Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
    // },
  ];

  const experienceDetails = [
    {
      yearRange: "2016 - 2017",
      title: "Jr. Web Developer",
      place: "Almighty Infosoft PVT LTD",
      project: "Direct Bazaar (CorePHP, MySQL, Jquery, Bootstrap)",
      desc: "Created one Portal to Show all products on different shopping sites like Flipkart, Amazon, Snapdeal and etc. It's a one-stop for all the necessary items in one portal which can be profitable/affordable for customers and sellers.",
    },
    {
      yearRange: "2017 - 2019",
      title: "Sr.Web Developer",
      place: "SiyaSoft - Surat",
      project: "PWP (Google Cloud, CorePHP , MySQL ,JQuery , Git)",
      desc: "Developed a website to manage your accounts, finances, purchases, sales inventory manufacturing process and etc in an easy and efficient manner. It is comprehensive accounting software that covers your business's needs and saves you time and energy. With PWP you can easily manage all areas of your company sitting in any corner of the globe and concentrate on your business growth. It is developed in Core PHP. It is a cloud that holds the bills, inventory, accounts, Eway bills, and GST reports.",
    },
    {
      yearRange: "2019 - 2021",
      title: "Sr.Software Engineer",
      place: "kautilyam - Surat",
      project: "Envigo (DRF, Django, Angular11, MySql, Git, Stripe, Python)",
      desc: "Created an Online Booking Platform for Parcel Deliveries. It helps users to find the best courier services in town. It lists all the cheapest and fastest deliveries throughout the town. The users can book the couriers online and get the best price on FedEx, DHL and many more courier services.",
    },
  
    // {
    //   yearRange: "2021 - 2023",
    //   title: "Senior Full Stack Developer & Team Lead",
    //   place: "Bluehole (OPC) Pvt Ltd",
    //   project: "Cardinatelent (Ruby And Rails , ReactJs, Postgresql, Git, AWS)",
    //   desc: "Created a website that acts as a Job Portal and an Application Tracking System, storing data of an applicant in different stages. It helps job seekers to find the best opportunity in the market by simply uploading their CVs. It finds the best-suited opportunity according to the skillsets and experience. It is a revolutionary development for recruiters making their work easier and more efficient. It also helps in organizing the candidates according to their stages which makes other recruiters in the organization communicate regarding different aspects efficiently.",
    // },
    // {
    //   // yearRange: "2021 - 2023",
    //   // title: "Senior Full Stack Developer & Team Lead",
    //   // place: "Bluehole (OPC) Pvt Ltd",
    //   project: "Cardinatelent (Ruby And Rails , ReactJs, Postgresql, Git, AWS)",
    //   desc: "Created a website that acts as a Job Portal and an Application Tracking System, storing data of an applicant in different stages. It helps job seekers to find the best opportunity in the market by simply uploading their CVs. It finds the best-suited opportunity according to the skillsets and experience. It is a revolutionary development for recruiters making their work easier and more efficient. It also helps in organizing the candidates according to their stages which makes other recruiters in the organization communicate regarding different aspects efficiently.",
    // },
  ];
  
const experienceDetails1 = [{
  yearRange: "2021 - Present",
  title: "Senior Full Stack Developer & Project Manager",
  place: "Bluehole (OPC) Pvt Ltd",
  projects:{
      pr1:{
        project: "Cardinatelent (Ruby And Rails , ReactJs, Postgresql, Git, AWS)",
        desc: "Created a website that acts as a Job Portal and an Application Tracking System, storing data of an applicant in different stages. It helps job seekers to find the best opportunity in the market by simply uploading their CVs. It finds the best-suited opportunity according to the skillsets and experience. It is a revolutionary development for recruiters making their work easier and more efficient. It also helps in organizing the candidates according to their stages which makes other recruiters in the organization communicate regarding different aspects efficiently.",
      },
      pr2:{
        project: "Datasort ( Python, Django, PostgreSQL, Git, AWS)",
        desc: "Use AI to do your resume parsing, and free your team to do the real work. Powered-by DataSort. World's number 1 Resume Parsing API.",
      },
      pr3:{
        project: "PingPronto ( Laravel, PHP, Mysql, Git, AWS, ChatGTP, Stripe)",
        desc: "PingPronto Applies for Jobs and Emails Marketing System.",
      }
  }
}];

  const skills = [
    {
      name: "Aws",
      percent: 65,
    },
    {
      name: "Core PHP",
      percent: 98,
    },
    {
      name: "Laravel",
      percent: 98,
    },
    {
      name: "CakePHP",
      percent: 85,
    },
    {
      name: "Symfony",
      percent: 75,
    },
    {
      name: "React JS",
      percent: 55,
    },
    {
      name: "Node.js",
      percent: 70,
    },
    {
      name: "Angular Js",
      percent: 65,
    },
    {
      name: "Git",
      percent: 99,
    },
    {
      name: "Ruby on Rails",
      percent: 75,
    },
    {
      name: "JQuery",
      percent: 70,
    },
    {
      name: "JavaScript",
      percent: 69,
    },
    {
      name: "Python",
      percent: 72,
    },
    {
      name: "Django",
      percent: 80,
    },
    {
      name: "Project Management",
      percent: 95,
    },
    {
      name: "Team Leader",
      percent: 95,
    },
  ];

  return (
    <section
      id="resume"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Summary
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Resume
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gx-5">
          {/* My Education */}
          <div className="col-md-12">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Education
            </h2>
            {educationDetails.length > 0 &&
              educationDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
          {/* My Experience */}
          <div className="col-md-12">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Experience
            </h2>
            {experienceDetails.length > 0 &&
              experienceDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.project}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
               {experienceDetails1.length > 0 &&
              experienceDetails1.map((value, index) =>  

             (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.projects.pr1.project}
                  </p><p className={darkTheme ? "text-primary" : "text-dark"}>
                    {value.projects.pr1.desc}
                  </p>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.projects.pr2.project}
                  </p><p className={darkTheme ? "text-primary" : "text-dark"}>
                    {value.projects.pr2.desc}
                  </p>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.projects.pr3.project}
                  </p><p className={darkTheme ? "text-primary" : "text-dark"}>
                    {value.projects.pr3.desc}
                  </p>
                </div>
              ))}
          </div>
        </div>
        {/* My Skills */}
        <h2
          className={
            "text-6 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
          }
        >
          My Skills
        </h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div key={index} className="col-md-6">
                <p
                  className={
                    " fw-500 text-start mb-2 " +
                    (darkTheme ? "text-light" : "text-dark")
                  }
                >
                  {skill.name}{" "}
                  <span className="float-end">{skill.percent}%</span>
                </p>
                <div
                  className={
                    "progress progress-sm mb-4 " + (darkTheme ? "bg-dark" : "")
                  }
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div>
        <div className="text-center mt-5">
          <a
            className="btn btn-outline-secondary rounded-pill shadow-none"
            href={resumeFile}
            download
          >
            Download CV
            <span className="ms-1">
              <i className="fas fa-download" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Resume;
